module.exports = __webpack_public_path__ + "img/corvette-exterior-v2.10221929.webp";